import { render, staticRenderFns } from "./DealerUsers.vue?vue&type=template&id=07b948fa&scoped=true"
import script from "./DealerUsers.vue?vue&type=script&lang=js"
export * from "./DealerUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b948fa",
  null
  
)

export default component.exports